import { pick } from 'lodash-es'

const transformToUpdateLocationInput = data => pick(data, ['name', 'website'])

export default transformToUpdateLocationInput
